// ── DEADLINE ALERT BANNER (fp-nofodesk-9) — extracted from App.js ──
import { daysUntilDeadline } from "../utils/grants";
import { useT } from "../theme";

// ── Feature 1: Deadline Alert Banner ─────────────────────────
function DeadlineAlertBanner({ activeGrants, applications, tracked, onDismiss }) {
  // Dark and black modes keep their colours; light mode gets a pale amber
  // banner instead of a near-black one on a white page.
  const T = useT();
  const P = T.mode === "light"
    ? { bg: "#FFF8EB", title: "#92400E", chipBg: "#FFFFFF", chipText: "#92400E", chipBorder: "#F5C77E", urgentBg: "#FDECEC", urgentText: "#991B1B", urgentBorder: "#F0B5B5" }
    : { bg: "#1a1000", title: "#fbbf24", chipBg: "#1a1000", chipText: "#fde68a", chipBorder: "#78350f", urgentBg: "#3b0a0a", urgentText: "#fca5a5", urgentBorder: "#7f1d1d" };
  const all = [
    ...applications.filter(a => a.deadline).map(a => ({ name: a.title, date: a.deadline })),
    ...tracked.filter(g => g.deadline && g.deadline !== "Not specified").map(g => ({ name: g.title, date: g.deadline })),
    ...(activeGrants || []).filter(g => g.end).map(g => ({ name: g.shortTitle || g.title, date: g.end })),
  ].map(d => ({ ...d, days: daysUntilDeadline(d.date) }))
   .filter(d => d.days !== null && d.days >= 0 && d.days <= 14)
   .sort((a, b) => a.days - b.days);
  if (all.length === 0) return null;
  return (
    <div style={{ background: P.bg, border: "1px solid #d97706", borderRadius: 8, padding: "10px 14px", marginBottom: 12, display: "flex", alignItems: "flex-start", gap: 10 }}>
      <span style={{ fontSize: 16, flexShrink: 0, marginTop: 1 }}>⏰</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: P.title, marginBottom: 5 }}>
          {all.length} deadline{all.length > 1 ? "s" : ""} in the next 14 days
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
          {all.slice(0, 5).map((d, i) => (
            <span key={i} style={{ fontSize: 11, padding: "2px 8px", borderRadius: 4,
              background: d.days <= 3 ? P.urgentBg : P.chipBg,
              color: d.days <= 3 ? P.urgentText : P.chipText,
              border: `1px solid ${d.days <= 3 ? P.urgentBorder : P.chipBorder}` }}>
              {d.days === 0 ? "Today" : d.days === 1 ? "Tomorrow" : `${d.days}d`} — {(d.name || "").slice(0, 40)}{(d.name || "").length > 40 ? "…" : ""}
            </span>
          ))}
          {all.length > 5 && <span style={{ fontSize: 11, color: "#d97706" }}>+{all.length - 5} more</span>}
        </div>
      </div>
      <button onClick={onDismiss} style={{ background: "transparent", border: "none", color: "#d97706", cursor: "pointer", fontSize: 18, lineHeight: 1, padding: "0 2px", flexShrink: 0 }}>×</button>
    </div>
  );
}
export default DeadlineAlertBanner;
